import { Box, Flex, Text } from '@chakra-ui/react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import React from 'react';
import type { TransactionProvider } from '../../interface/transactionCodes';
import { INK, INK_MUTED, INK_SOFT, ROW_GAP } from '../../styles/tokens';
import { SectionLabel } from './CodeSection';

export const ProvidersSection: React.FC<{ readonly providers: readonly TransactionProvider[] }> = ({ providers }) => (
  <Box role="group" aria-label="Providers" data-section="providers">
    <Flex align="center" gap="6px">
      <SectionLabel>Providers</SectionLabel>
      <Box
        as="span"
        role="button"
        aria-label="Edit providers"
        aria-disabled="true"
        tabIndex={0}
        title="Editing providers is not available yet"
        cursor="not-allowed"
        color={INK_MUTED}
        display="inline-flex"
      >
        <BiomeIcon iconName={IconName.Edit} />
      </Box>
    </Flex>
    {providers.length === 0 ? (
      <Text fontSize="12px" color={INK_MUTED} mt="4px">No providers</Text>
    ) : (
      providers.map((provider) => (
        <Flex key={provider.id} align="center" gap="8px" mt={ROW_GAP} data-testid={`provider-${provider.id}`}>
          <Text as="span" fontSize="12px" fontWeight={600} color={INK}>
            {provider.credentials ? `${provider.name}, ${provider.credentials}` : provider.name}
          </Text>
          {provider.providerType && (
            <Text as="span" fontSize="12px" color={INK_SOFT}>{provider.providerType}</Text>
          )}
          <Text as="span" ml="auto" fontSize="10px" fontWeight={700} letterSpacing="0.06em" color={INK_SOFT} data-testid={`provider-roles-${provider.id}`}>
            {provider.roles.map((role) => role.label.toUpperCase()).join(' · ')}
          </Text>
        </Flex>
      ))
    )}
  </Box>
);
